import Causes from "./Causes";
import Contact from "./Contact";
import Hero from "./Hero";
import Impact from "./Impact";
import Introduction from "./Introduction";
import Mission from "./Mission";
import PartnersSection from "./Partners";
import Vision from "./Vision";

export default function Main() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Hero Section */}
      <Hero />

      {/* About Section */}
      <section className="relative overflow-x-hidden bg-gradient-to-br from-green-50 to-white">
        <Introduction />

        <Mission />
        <Vision />
      </section>

      {/* Causes Section */}
      <section className="overflow-x-hidden bg-gradient-to-br from-green-50 to-green-100 py-16">
        <Causes />
      </section>

      {/* Impact Section */}
      <section className="overflow-x-hidden bg-white py-16">
        <Impact />
      </section>

      {/* Partners Section */}
      <section className="overflow-x-hidden bg-green-50 py-16">
        <PartnersSection />
      </section>

      {/* Contact Section */}
      <section className="overflow-x-hidden bg-gradient-to-br from-green-800 to-green-700 py-16">
        <Contact />
      </section>
    </div>
  );
}
